<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import RegionalRequest from 'Modules/contacard/produto/marca/regional/RegionalRequest';

export default {
  name: 'RegionalCrudList',
  extends: CrudListVue,
  props: {
    marcaId: {
      type: [Number, String],
      default: null,
    },
  },
  data: () => ({
    requestClass: RegionalRequest,
    hideEdit: true,
    hideDelete: true,
    headers: [
      {
        text: 'Regional',
        value: 'nomRegional',
      },
      {
        text: 'Código',
        value: 'id',
      },
      {
        text: 'Atualização',
        value: 'updatedDate',
        component: 'DataTableDateColumn',
      },
    ],
  }),
  computed: {
    getMarcaId() {
      return this.marcaId;
    },
  },
  methods: {
    prepareRequest(params) {
      return this.requestClass
        .list(params, this.getMarcaId);
    },
  },
};
</script>
